import { PopperPlacementType } from "@mui/base/Popper";
import { ClickAwayListener } from "@mui/material";
import { Dropdown } from "@redotech/arbiter/dropdown";
import { Flex } from "@redotech/arbiter/flex";
import {
  RedoTagInputField,
  redoTagDelimiter,
} from "@redotech/arbiter/input/redo-tag-input-field";
import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import { memo, useState } from "react";

export const ArrayStringTextValueEditor = memo(
  function ArrayStringTextValueEditor({
    anchor,
    multiValue,
    open,
    placeholder,
    placement,
    setOpen,
    setValues,
    values,
  }: {
    anchor: HTMLElement | null;
    multiValue?: boolean;
    open: boolean;
    placeholder?: string;
    placement?: PopperPlacementType;
    setOpen(open: boolean): void;
    setValues(values: string[]): void;
    values: string[];
  }) {
    const [inputValue, setInputValue] = useState("");

    return (
      <>
        {open && (
          <ClickAwayListener onClickAway={() => setOpen(false)}>
            <Dropdown
              anchor={anchor}
              fitToAnchor={false}
              open={open}
              placement={placement}
            >
              <Flex dir="column" p="sm">
                {multiValue ? (
                  <RedoTagInputField
                    autoFocus
                    delimiters={[...redoTagDelimiter]}
                    inputValue={inputValue}
                    placeholder={placeholder}
                    setInputValue={setInputValue}
                    setTags={setValues}
                    tags={values.map((v) => ({ text: v }))}
                  />
                ) : (
                  <RedoTextInput
                    autoFocus
                    fullWidth={false}
                    placeholder={placeholder}
                    setValue={(v) => setValues([v])}
                    state="default"
                    value={values[0] ?? ""}
                  />
                )}
              </Flex>
            </Dropdown>
          </ClickAwayListener>
        )}
      </>
    );
  },
);
